export default __webpack_public_path__ + "static/media/Version (5) - Deathly Hallows_01.e772ec08.jpg";